
define('text!templates/pages/news/tag.ejs',[],function () { return '<a href="<%= url(\'news#list\', { tag: (ID===-1) ? \'\' : encodeURIComponent(Name) }) %>" class="<% if (selected) {%>selected<% } %>" style="font-size: <%= fontSize %>px"><%= Name %></a>';});

